import{jsxs as e,jsx as t}from"react/jsx-runtime";import r from"../../assets/icons/search.svg.js";import n from"styled-components";import{COLORS as o}from"../../constants/Theme.js";import{TitleMedium as i,BodySecondary as s}from"../TypographyStyle.js";const c=n=>e(a,Object.assign({height:n.height},{children:[t(d,{children:t(r,{width:24,height:24,color:o.background.brand})}),e("div",Object.assign({style:{textAlign:"center"}},{children:[t(i,{children:"No results found"}),n.searchText?t(s,Object.assign({style:{color:o.content.secondary,marginTop:8}},{children:`Sorry we could not find any results for "${n.searchText}"`})):t(s,Object.assign({style:{color:o.content.secondary,marginTop:8}},{children:"Sorry we could not find any variables"}))]}))]})),a=n.div`
	display: flex;
	gap: 16px;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 0 16px;
	height: ${e=>e.height};
`,d=n.div`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${o.background.brandLight};
	width: 48px;
	height: 48px;
	border-radius: 24px;
`;export{c as default};
